import type { UnitConversionDef, UnitDef } from "./types";

export const UNIT_PIECE: UnitDef = {
  code: "pc",
  name: { en: "Piece", bn: "পিস" },
  fractional: false,
};
export const UNIT_KG: UnitDef = {
  code: "kg",
  name: { en: "Kilogram", bn: "কেজি" },
  fractional: true,
};
export const UNIT_G: UnitDef = { code: "g", name: { en: "Gram", bn: "গ্রাম" }, fractional: true };
export const UNIT_L: UnitDef = { code: "l", name: { en: "Litre", bn: "লিটার" }, fractional: true };
export const UNIT_ML: UnitDef = {
  code: "ml",
  name: { en: "Millilitre", bn: "মিলি" },
  fractional: true,
};
export const UNIT_DOZEN: UnitDef = {
  code: "dz",
  name: { en: "Dozen", bn: "ডজন" },
  fractional: false,
};
export const UNIT_PACKET: UnitDef = {
  code: "pkt",
  name: { en: "Packet", bn: "প্যাকেট" },
  fractional: false,
};
export const UNIT_BOX: UnitDef = { code: "box", name: { en: "Box", bn: "বক্স" }, fractional: false };

export const METRIC_CONVERSIONS: readonly UnitConversionDef[] = [
  { from: "kg", to: "g", factor: 1000 },
  { from: "l", to: "ml", factor: 1000 },
  { from: "dz", to: "pc", factor: 12 },
];
